var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('router-view'),(_vm.getIsToastPopup)?_c('ToastPopup',{attrs:{"getIsToastPopup":_vm.getIsToastPopup,"getIsToastData":_vm.getIsToastData}}):_vm._e(),(_vm.getIsSelectDropBox)?_c('DropBoxSelect'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }